//var check = {
//    Android: function() {
//        return navigator.userAgent.match(/Android/i);
//    },
//    BlackBerry: function() {
//        return navigator.userAgent.match(/BlackBerry/i);
//    },
//    iOS: function() {
//        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
//    },
//    Opera: function() {
//        return navigator.userAgent.match(/Opera Mini/i);
//    },
//    Windows: function() {
//        return navigator.userAgent.match(/IEMobile/i);
//    },

//    isMobile: function() {
//        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
//    }
//};

var mobileCheck = {
    ios: (function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }()),
    android: (function () {
        return navigator.userAgent.match(/Android/i);
    }()),
    blackBerry: (function () {
        return navigator.userAgent.match(/BB10|Tablet|Mobile/i);
    }()),
    windows: (function () {
        return navigator.userAgent.match(/IEMobile/i);
    }()),
    smartphone: (function () {
        return (window.innerWidth <= 384 && window.innerHeight <= 640);
    }()),
    tablet: (function () {
        return (navigator.userAgent.match(/Tablet|iPad|iPod/i) && window.innerWidth <= 1280 && window.innerHeight <= 800);
    }()),
    all: (function () {
        return navigator.userAgent.match(/Android|BlackBerry|Tablet|Mobile|iPhone|iPad|iPod|Opera Mini|IEMobile/i);
    }())
};